// «Pidió una propuesta»: a structured mark in the activity (Outreach › Notes), without a new field. Shared by the
// follow-up panel and by airtable-proxy, which validates its meaning on every write (tested by
// scripts/test-next-actions.mjs):
//   - the mark goes only on an answer of the contact (a reply status);
//   - on an existing record it can only be prepended to the notes, alone in the change (the rest stays as it was);
//   - once there, it is never removed and the record never stops being an answer.
import { REPLY_STATUS_NAMES } from './replyStatuses.js';

export const PROPOSAL_REQUEST_MARK = '[oike:pidio-propuesta]';
const val = (v) => (v && typeof v === 'object' && !Array.isArray(v) ? (v.name ?? v.value ?? '') : (v ?? ''));
export const hasProposalRequest = (notes) => String(val(notes) || '').includes(PROPOSAL_REQUEST_MARK);
/** The notes of an existing answer with the mark prepended (unchanged when it already has it). */
export const withProposalMark = (notes) => (hasProposalRequest(notes) ? String(notes || '') : `${PROPOSAL_REQUEST_MARK} ${String(notes || '')}`.trimEnd());

/**
 * The problem of one Outreach write with respect to the mark, or null. `current` is the record before a PATCH
 * (its fields), null on a create.
 */
export function proposalMarkProblem({ method, fields = {}, current = null }) {
  const f = fields || {};
  const has = (k) => Object.prototype.hasOwnProperty.call(f, k);
  const before = current || {};
  const markedBefore = hasProposalRequest(before['Notes']);
  const notesAfter = has('Notes') ? f['Notes'] : before['Notes'];
  const statusAfter = String(val(has('Status') ? f['Status'] : before['Status']) || '');
  const markedAfter = hasProposalRequest(notesAfter);
  if (method === 'PATCH' && markedBefore && !markedAfter) return 'proposal_mark_removed';
  if (!markedAfter) return null;
  if (!REPLY_STATUS_NAMES.has(statusAfter)) return 'proposal_mark_status';
  if (method === 'PATCH' && !markedBefore) {
    // Added to an existing answer: only the mark, prepended, and nothing else in the same change
    const others = Object.keys(f).filter(k => k !== 'Notes');
    if (others.length || String(f['Notes'] ?? '') !== withProposalMark(before['Notes'])) return 'proposal_mark_path';
  }
  return null;
}
